var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"h-full"},[_c('v-card-text',[_c('canvas',{ref:"chart"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }